import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Dropdown, Form, Icon, Menu, Segment } from 'semantic-ui-react'
import { UseForm } from '../Hooks/UseForm'
import { SalirApp } from '../Reducers/InicioReducer'
import { CerrarPopup, MostrarPopup } from '../Reducers/PopupReducer'
import { ColocarOrden } from './ColocarOrden'
import { MonedaDetalleRender } from './MonedaDetalle'
import { MonedasRender } from './Monedas'
import { MonitorOrdenes } from './Ordenes/MonitorOrdenes'
import numeral from 'numeral'
import { ObtenerLibrosAsync } from '../Servicios/ServiciosPublicos'
import { GraficaSaldo } from './GraficaSaldo'

export const PrincipalMobile = (params) => {

    const dispatch = useDispatch();

    const [internalState, setInternalState] = useState({
        MonedaDetalle: null,
        Libros: [],
        Contenido: 1,//1.- Principal 2.- Monedas 3.-Ordenes Activas
    })
    useEffect(() => {
        Load();
        const _objInt = setInterval(() => { ObtenerLibros(); }, 10000);
        return () => { if (_objInt) { clearInterval(_objInt); } };
    }, []);

    useEffect(() => {
        setInternalState((state) => ({ ...state, Contenido: !!internalState.MonedaDetalle ? 2 : 1 }));
    }, [internalState.MonedaDetalle])

    const Load = () => { ObtenerLibros(); }
    const ObtenerLibros = async () => {
        let _libros = await ObtenerLibrosAsync();
        setInternalState((state) => ({ ...state, Libros: _libros }));
    }
    const OnMonedaDetalleChange = (item) => {
        setInternalState((state) => ({ ...state, MonedaDetalle: item }));
    }
    const OnClickBack = () => {
        if (internalState.Contenido === 1) {
            dispatch(SalirApp());
        } else {
            setInternalState((state) => ({ ...state, MonedaDetalle: null, MonedaDetalleDetalle: [], Contenido: 1 }));
        }
    }
    const OnClickCrearOrden = async () => {

    }
    const OnClickColocarOrden = async () => {
        // debugger
        dispatch(MostrarPopup({
            Titulo: `Colocar Orden`,
            Content: (<ColocarOrden
                MonedaDetalle={internalState.MonedaDetalle}
            />),
            Cerrar: (r) => {

            }
        }))
    }
    const OnClickOrdenesActivas = async () => {
        setInternalState((state) => ({ ...state, Contenido: internalState.Contenido === 1 ? 3 : 1 }));
    }
    const OnClickGrafica = async () => {
        setInternalState((state) => ({ ...state, Contenido: 4 }));
    }
    return (<>
        <div className={`bitso-mobile${params.EsDesktop ? "-desktop" : ""}`}>
            <div className="bitso-mobile-content">
                {internalState.Contenido === 1 && (<MonedasRender OnMonedaDetalleChange={OnMonedaDetalleChange} />)}
                {internalState.Contenido === 2 && (<MonedaDetalleRender MonedaDetalle={internalState.MonedaDetalle} />)}
                {internalState.Contenido === 3 && (<MonitorOrdenes />)}
                {internalState.Contenido === 4 && (<GraficaSaldo />)}

            </div>
        </div>
        <div className="bitso-mobile-footer">
            <Menu inverted>
                <Dropdown text={"Ultimos Precios..."} pointing className='link item'>
                    <Dropdown.Menu inverted>
                        {
                            internalState.Libros.map(libro => (
                                <Dropdown.Item>
                                    <div className="div-ultimos-precios-item">
                                        <div>{libro.book.replace("_mxn", "")}</div>
                                        <div>{numeral(+libro.last).format("0,000.00")}</div>
                                    </div>
                                </Dropdown.Item>
                            ))
                        }
                    </Dropdown.Menu>
                </Dropdown>
                {
                    internalState.Contenido === 1 && (<>
                        <Menu.Item onClick={OnClickOrdenesActivas}><Icon name="sort amount down" ></Icon></Menu.Item>
                        <Menu.Item onClick={OnClickGrafica}><Icon name="chart pie" ></Icon></Menu.Item>
                        <Menu.Item position="right" onClick={OnClickBack}><Icon name={"sign-out"} ></Icon></Menu.Item>

                    </>)
                }
                {
                    internalState.MonedaDetalle && (<>
                        <Menu.Item onClick={OnClickColocarOrden}><Icon name="plus" ></Icon></Menu.Item>
                    </>)
                }
                {
                    internalState.Contenido > 1 && (<Menu.Item onClick={OnClickBack}><Icon name="home" ></Icon></Menu.Item>)
                }

            </Menu>
        </div>
    </>)
}
